import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
	name: 'displayLieu'
})

export class DisplayLieuPipe implements PipeTransform {
	address: string
	transform(tiers: any, ...args: any[]) {
		if (tiers) {
			const principal = this.__get__address__principal__(tiers.adresses)
			console.log(principal)
			if (principal) {
				this.address='';
				if (principal.number!=undefined &&
				
				 principal.number && parseInt(principal.number)>0 ) {
					this.address += principal.number + ' '
				}
				if (principal.complement) {
					this.address += principal.complement + ' '
				}
				if (principal.street) {
					this.address += principal.street + ' '
				}
				if (principal.zip) {
					this.address += '(' + principal.IDzipcode + ') '
				}
				if (principal.town) {
					this.address += principal.town
				}
			} else {
				this.address = 'Aucun lieu ou adresse non renseignée'
			}
		}
		return this.address
	}
	private __get__address__principal__(adresses: any) {
		return adresses.PRINCIPALE ? adresses.PRINCIPALE : null
	}
}
